import { useEffect, useState } from 'react'

export function ArchivedModal() {
  const [open, setOpen] = useState(true)

  // useEffect(() => {
  //   const dismissed = localStorage.getItem('archived-modal-dismissed')
  //   if (!dismissed) setOpen(true)
  // }, [])

  useEffect(() => {
    function handleEsc(e) {
      if (e.key === 'Escape') close()
    }
    if (open) window.addEventListener('keydown', handleEsc)
    return () => window.removeEventListener('keydown', handleEsc)
  }, [open])

  function close() {
    setOpen(false)
    // localStorage.setItem('archived-modal-dismissed', 'true')
  }

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/70 px-4 backdrop-blur-sm"
      onClick={close}
    >
      <div
        className="relative max-w-lg rounded-3xl bg-white p-8 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={close}
          className="absolute right-4 top-4 text-slate-400 hover:text-slate-700"
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold text-slate-950">
          Archived project
        </h2>

        <p className="mt-4 text-sm leading-6 text-slate-700">
  Digitalfalse — archived AI-text detection experiment. <br/> <br/>

  I’ve long been interested in computer-generated media, especially text and images, and even wrote two theses on the subject.  <br/> <br/>

            Early models like GPT-2 and GPT-3 left detectable patterns, but modern LLMs have reached a level where short-form detection is no longer reliable.

  This project explored those limits - and ultimately showed that without broader context, confidently classifying text as human or AI-generated is far more difficult than it first appears.
</p>

        <button
          onClick={close}
          className="mt-6 w-full rounded-xl bg-slate-950 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800"
        >
          Continue to site
        </button>
      </div>
    </div>
  )
}